<template>
  <b-container class="mt-5">
    <b-row>
        <b-col offset-md="3" cols="6">
          <b-card header="Update your profile">
            <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
              <b-form-group id="name-label" label="Name:" label-for="name">
                <b-form-input id="name" v-model="name" type="text" required placeholder="Enter name"></b-form-input>
              </b-form-group>
              <b-form-group id="email-label" label="Email address:" label-for="email">
                <b-form-input id="email" v-model="email" type="email" required placeholder="Enter email"></b-form-input>
              </b-form-group>
              <b-form-group id="password-label" label="Password:" label-for="password">
                <b-form-input id="password" v-model="password" type="password" placeholder="Enter password"></b-form-input>
              </b-form-group>
              <b-button type="submit" variant="primary">Update profile</b-button>
            </b-form>  
          </b-card>
        </b-col>
    </b-row>
  </b-container>
</template>
<script>
import {mapState} from 'vuex'
export default {
  computed: {
    ...mapState(['user', 'displayName']),
  },
  mounted() {
    this.onReset()
  },
  data() {
    return {
      name: '',
      email: '',
      password: '',
    }
  },
  methods: {
    async onSubmit() {
      this.$auth.updateUser(this.user, this.email, this.password, this.name)
    },
    onReset() {
      this.name = this.displayName
      this.email = this.user.email
      this.password = ''
    }
  }
}
</script>